<div class="iframe-container">
  <iframe
    *ngIf="videoId"
    [src]="'https://www.youtube.com/embed/' + videoId | SafeUrl"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  >
  </iframe>
</div>
